module.exports = __webpack_public_path__ + "static/img/banner.4fefebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/banner.png
// module id = crs0
// module chunks = 1